function e() {
  return typeof process > "u" || !process.env ? {} : process.env;
}
export {
  e as getProcessEnv
};
//# sourceMappingURL=index30.js.map
